/** @format */

import React, { useState } from 'react'
import styled from 'styled-components'
import { _$, Button, ButtonGroup, Copy } from '@king-design/react'
import { getAppKey } from 'src/api/ApiAIObservability'
import { useAsync } from 'react-use'
import { OpenLLMetryIcon, OpenTelemetryIcon, LangfuseIcon } from '../icons/DrawerIcons'
import OpenLLMetry from './OpenLLMetry'
import OpenTelemetry from './OpenTelemetry'
import Langfuse from './Langfuse'
import { useLocation, useHistory } from 'react-router'
import { replaceSearchParams } from 'src/utils'

type CollectionKind = 'openLLMetry' | 'openTelemetry' | 'langfuse'

interface PythonDrawerProps {
  className?: string
  region: string
}

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export const renderHTTPAddress = (region: string) => {
  return (
    <>
      <b>{_$('HTTP端口')}：</b>
      <p style={{ marginLeft: 8 }}>
        {_$('公网地址')}：<i>https://{region}.otlp.ksyun.com:4318</i>
        <Copy text={`https://${region}.otlp.ksyun.com:4318`} />
      </p>
      <p style={{ marginLeft: 8 }}>
        {_$('内网地址')}：<i>http://{region}.internal.otlp.ksyun.com:4318 </i>
        <Copy text={`http://${region}.internal.otlp.ksyun.com:4318`} />
      </p>
      <b>{_$('GRPC端口')}：</b>
      <p style={{ marginLeft: 8 }}>
        {_$('公网地址')}：<i>https://{region}.otlp.ksyun.com:4317</i>
        <Copy text={`https://${region}.otlp.ksyun.com:4317`} />
      </p>
      <p style={{ marginLeft: 8 }}>
        {_$('内网地址')}：<i>http://{region}.internal.otlp.ksyun.com:4317 </i>
        <Copy text={`http://${region}.internal.otlp.ksyun.com:4317`} />
      </p>
    </>
  )
}

const PythonDrawer: React.FC<PythonDrawerProps> = ({ className, region }) => {
  const history = useHistory()
  const location = useLocation()
  const query = useQuery()
  const query_collection = query.get('collection') as CollectionKind
  const [collection, setCollection] = useState<CollectionKind>(query_collection || 'openLLMetry')

  const { value: appInfo } = useAsync(async () => {
    const result = await getAppKey()
    return result?.AppInfo
  }, [])

  return (
    <section className={className} aria-labelledby="collection-heading">
      <h3 id="collection-heading" className="panel-label">
        {_$('接入协议类型')}
      </h3>
      <div className="panel-content">
        <ButtonGroup
          checkType="radio"
          value={collection}
          onChangeValue={collection => {
            setCollection(collection)
            replaceSearchParams(history, location, { collection: collection })
          }}
          btnWidth="200px"
        >
          <Button value="openLLMetry">
            <OpenLLMetryIcon />
            <span style={{ marginLeft: '8px' }}> {_$('OpenLLMetry SDK')}</span>
          </Button>
          <Button value="openTelemetry">
            <OpenTelemetryIcon />
            <span style={{ marginLeft: '8px' }}> {_$('OpenTelemetry SDK')}</span>
          </Button>
          <Button value="langfuse">
            <LangfuseIcon />
            <span style={{ marginLeft: '8px' }}> {_$('Langfuse SDK')}</span>
          </Button>
        </ButtonGroup>
      </div>
      <h3 id="collection-heading" className="panel-label">
        {_$('接入指南')}
      </h3>
      {collection === 'openLLMetry' && (
        <OpenLLMetry
          appKey={appInfo?.AppKey}
          region={region}
          visible={collection === 'openLLMetry'}
        />
      )}
      {collection === 'openTelemetry' && (
        <OpenTelemetry
          appKey={appInfo?.AppKey}
          region={region}
          visible={collection === 'openTelemetry'}
        />
      )}
      {collection === 'langfuse' && (
        <Langfuse
          visible={collection === 'langfuse'}
          publicKey={appInfo?.LangfusePublicKey}
          secretKey={appInfo?.LangfuseSecretKey}
          region={region}
        />
      )}
    </section>
  )
}

export default styled(PythonDrawer)`
  padding: 16px 8px;
  &:last-child {
    margin-bottom: 0;
  }

  .panel-label {
    margin: 0 0 12px;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .panel-content {
    padding-bottom: 16px;
    .k-btns {
      .k-btn {
        height: 40px;
      }
    }
  }
  .k-step {
    width: 724px;
    .k-step-main {
      width: 724px;
      padding-bottom: 24px !important;
      .k-step-title {
        font-weight: 500;
      }
      p {
        margin: 4px 0;
        line-height: 22px;
      }
      .k-step-content {
        color: #333;
        & > p {
          display: flex;
          align-items: center;
        }
      }
    }
    .code-block {
      padding: 8px;
      background-color: #f5f5f5;
      p {
        color: #333;
        margin: 4px 0;
      }
    }
    &.k-active {
      .k-step-mark {
        background-color: rgb(190, 195, 197) !important;
        border: none;
      }
      .k-step-title {
        color: #3c4449 !important;
      }
    }
  }
  .copy_text {
    color: #0091ea;
    cursor: pointer;
  }
  .k-icon {
    margin-left: 4px;
  }
`
